export default "__VITE_ASSET__Bhkhr8xw__"